import { Component, computed, effect, signal, viewChildren, inject } from '@angular/core';
import { ServiceSettingsMeasuredValuesStore } from './service-settings-measured-values-store.service';
import { TableColumnType } from '../../../../../shared/components/kit/table/table.types';
import { globalStore, routeParams } from '../../../../../shared/shared.global-service';
import { contentGlobalSuccess } from '../../../../content.error';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import {
    MeasuredValueType,
    SERVICE_SETTINGS_MEASURED_VALUES_TYPE_DEFAULT,
    SERVICE_SETTINGS_MEASURED_VALUES_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-measured-value.type';
import { selectServiceSettings } from '../../../../store/service/service.selectors';
import { CardComponent } from '../../../../../../components/kit/card/card.component';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-settings-measured-values',
    templateUrl: './service-settings-measured-values.component.html',
    styleUrl: './service-settings-measured-values.component.scss',
    providers: [ServiceSettingsMeasuredValuesStore],
    imports: [
        CardComponent,
        TableComponent,
        PrimeTemplate,
        TranslatePipe,
        CheckInputComponent,
        SvgIconComponent,
        ActionButtonsComponent,
    ],
})
export class ServiceSettingsMeasuredValuesComponent {
    protected readonly store = inject(ServiceSettingsMeasuredValuesStore);


    protected readonly useChecks = viewChildren(CheckInputComponent);

    protected columns = [
        { name: 'use', type: TableColumnType.Bool },
        { name: 'name' },
        { name: 'description' },
        { name: 'icon' },
    ];

    // TODO zobecnit merge s defaults... ideálně v novějším signal přístupu, než ze starého store
    protected defaultSetting = computed(() => {
        const settings = globalStore!.selectSignal(
            selectServiceSettings(SERVICE_SETTINGS_MEASURED_VALUES_TYPE_KEY, SERVICE_SETTINGS_MEASURED_VALUES_TYPE_DEFAULT),
        )();
        Object.entries(SERVICE_SETTINGS_MEASURED_VALUES_TYPE_DEFAULT.values).forEach(([key, value]) => {
            if (!(key in settings.values)) {
                settings.values[key] = value;
            }
        });

        return settings;
    });

    protected measuredValuesSettings = computed(() => {
        const settings = this.defaultSetting();
        if (!settings) return signal({ values: [] });

        return signal({ ...settings });
    });

    constructor() {
        effect(() => {
            const checks = this.useChecks();
            this.defaultSetting()?.values?.forEach((it: any, index: number) => {
                if (it.use) {
                    checks?.[index]?.setSelected(true);
                }
            });
        });
    }

    public async save(): Promise<void> {
        const serviceId = routeParams.serviceId();
        if (!serviceId) return;

        const data = {
            values: this.measuredValuesSettings()().values,
        };

        await this.store.api.updateServiceSettings({
            key: SERVICE_SETTINGS_MEASURED_VALUES_TYPE_KEY,
            data: JSON.stringify(data),
            serviceId: Number(serviceId),
        });
        contentGlobalSuccess.next('common.updated');
    }

    protected useItem(data: MeasuredValueType, selected: any) {
        this.measuredValuesSettings().update((it) => {
                it.values = it.values.map((item: MeasuredValueType) =>
                    item.name === data.name ? { ...item, use: selected } : item,
                );
                return it;
            },
        );
    }
}
